import { api, scope } from 'cssapi'
import Img from 'gatsby-image'
import PropTypes from 'prop-types'
import React from 'react'
import styled from 'styled-components'
import { fieldsTitle, frontmatterImageSizes } from '../../helpers/markdown'
import HLayout from '../../shared/layouts/HLayout'
import VLayout from '../../shared/layouts/VLayout'
import TitleSecondary from '../../shared/titles/TitleSecondary'

const Title = styled(TitleSecondary)`
  position: relative;
  font-weight: bold;
`

const ImgLayout = styled.div`
  ${api({
    flex: scope`0 0 2.5ru`,
  })};
`

const TextLayout = styled(VLayout)`
  width: 100%;
`

const Layout = styled.div`
  position: relative;
`

const ProjectsListItem = ({ project }) => (
  <Layout>
    <HLayout>
      <ImgLayout>
        <Img sizes={frontmatterImageSizes(project)} />
      </ImgLayout>
      <TextLayout spacing="small">
        <Title>{fieldsTitle(project)}</Title>
        <p>{project.excerpt}</p>
      </TextLayout>
    </HLayout>
  </Layout>
)

ProjectsListItem.propTypes = {
  project: PropTypes.object.isRequired,
}

export default ProjectsListItem



// WEBPACK FOOTER //
// ./src/components/ProjectsPage/ProjectsList/ProjectsListItem.jsx